import { DataMarketplaceCodes } from '@/common/enums/data-marketplace-codes.enum';
import Validatable from '@/validator/Validatable';

export interface IDataMarketplaceApi {
  datamarketplace_id: number;
  code: string;
  name: string;
  url: string;
}

export default class DataMarketplace extends Validatable<DataMarketplace> {
  constructor(
    public id: number,
    public code: DataMarketplaceCodes,
    public name: string,
    public url: string,
  ) {
    super();
  }

  static fromApi(apiObject: IDataMarketplaceApi): DataMarketplace {
    return new DataMarketplace(
      apiObject.datamarketplace_id,
      apiObject.code as DataMarketplaceCodes,
      apiObject.name,
      apiObject.url,
    );
  }

  toApi(): IDataMarketplaceApi {
    return {
      datamarketplace_id: this.id || undefined,
      code: this.code,
      name: this.name,
      url: this.url,
    };
  }
}
